var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoutRed = function SvgLogoutRed(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.53 2.655V4.995L15.03 3.51V0.75L14.28 0H0.78L0.03 0.75V1.479L0 1.5V16.935L0.54 17.625L8.04 20.205L9 19.5V18H14.28L15.03 17.25V14.535L13.53 13.035V16.5H9V4.065L8.505 3.375L3.054 1.5H13.53V2.655ZM7.5 18.42L1.5 16.41V2.58L7.5 4.59V18.42ZM17.28 9.72H9.825V8.22H17.22L14.82 5.82L15.885 4.77L19.59 8.46V9.525L15.855 13.245L14.805 12.195L17.28 9.72Z",
    fill: "#d32f2f"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoutRed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "logout-red.31c3f22dabf29df26076d6b6a8877314.svg";